import { createPortal } from "react-dom";

/**
 * Draws dialogs on the homepage root so fixed layers escape event-card transforms
 * and keep the same stacking as the registration drawer. Inline when that root
 * is not mounted (unit tests).
 */
export function EventOverlay({ children }) {
  const home = document.querySelector(".smym-home");
  if (!home) return children;
  return createPortal(children, home);
}
